import { render, staticRenderFns } from "./MoreSVG.vue?vue&type=template&id=0623db94&"
import script from "./MoreSVG.vue?vue&type=script&lang=js&"
export * from "./MoreSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports